// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__DRcIB","footer":"ModalCreateQualiphyProcedure_footer__2ZmIM","additionData":"ModalCreateQualiphyProcedure_additionData__1nFyL"};